import { useUi } from '../store';

/**
 * The scoreboard, and one way onward.
 *
 * Winning used to hand you the next level directly. That was wrong for a game
 * whose levels run five or six waves: by the time you clear one you have
 * jewels to spend, a planet to upgrade and a map that just grew a node, and
 * dropping you straight into the next fight hides all three. A win goes to the
 * map now. Losing still offers a retry, because there the useful next thing is
 * obviously the same level again.
 */
export default function Results({
  outcome,
  earned,
  onRetry,
  onMap,
}: {
  outcome: { won: boolean; stars: number; damage: number } | null;
  earned: number;
  onRetry: () => void;
  onMap: () => void;
}): JSX.Element {
  const hud = useUi((s) => s.hud);
  const won = outcome?.won ?? false;

  return (
    <div className="menu">
      <div className="results">
        <p className="menu-eyebrow">{won ? 'System held' : 'Core breached'}</p>
        <h1 className="results-title">{won ? 'Cleared' : 'Lost'}</h1>
        {won && (
          <div className="results-stars">
            {'\u2605'.repeat(outcome?.stars ?? 0)}
            {'\u2606'.repeat(3 - (outcome?.stars ?? 0))}
          </div>
        )}
        {won && earned > 0 && (
          <p className="results-jewels">
            <span className="jewel" />+{earned}
          </p>
        )}
        <p className="results-line">{hud.kills} destroyed</p>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        {!won && (
          <button className="ghost" onClick={onMap}>
            Map
          </button>
        )}
        <button
          className="primary"
          style={{ marginTop: 0 }}
          onClick={won ? onMap : onRetry}
        >
          {won ? 'Continue' : 'Retry'}
        </button>
      </div>
    </div>
  );
}
